/* Native details supplies keyboard behavior and works without JavaScript.
   Delegation also handles Shopify section reloads without duplicate listeners. */
(function () {
  if (window.ibSubcollectionsInitialized) return;
  window.ibSubcollectionsInitialized = true;
  document.addEventListener('toggle', function (event) {
    var group = event.target;
    if (!group.matches || !group.matches('.ib-subcollections__group') || !group.open) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var content = group.querySelector(':scope > .ib-subcollections__content');
    if (content && content.animate) {
      content.animate([{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'ease-out' });
    }
  }, true);
}());
